module.exports = __webpack_public_path__ + "img/4064009260.3f91bfb2.jpg";